import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './QuizHome.scss'
import { MdImage, MdTextFields } from 'react-icons/md'

const quizTypes = [
  {
    to: '/quiz/1',
    icon: MdImage,
    primary: 'Image Quiz',
    secondary: 'ਚਿੱਤਰ ਕਵਿਜ਼',
    desc: 'Match Punjabi letters to pictures',
    descPunjabi: 'ਤਸਵੀਰਾਂ ਨਾਲ ਅੱਖਰ ਮਿਲਾਓ',
    badge: 'Visual',
    color: 'amber',
  },
  {
    to: '/quiz/2',
    icon: MdTextFields,
    primary: 'Text Quiz',
    secondary: 'ਟੈਕਸਟ ਕਵਿਜ਼',
    desc: 'Read and choose the correct answer',
    descPunjabi: 'ਪੜ੍ਹੋ ਅਤੇ ਸਹੀ ਜਵਾਬ ਚੁਣੋ',
    badge: 'Reading',
    color: 'indigo',
  },
]

const QuizHome = ({ Helmet }) => {

  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  return (
    <div className='quizhome'>
      <Helmet>
        <title>Play Punjabi Quiz | Punjabi Academy</title>
        <meta name="description" content="Test your Punjabi knowledge with interactive quizzes on alphabet images and text. Fun for kids and beginners." />
      </Helmet>

      <div className='quizhome_Hero'>
        <p className='quizhome_Eyebrow'>ਕਵਿਜ਼ ਖੇਡੋ · Play Quiz</p>
        <h1 className='quizhome_Title'>Choose a Quiz Type</h1>
        <p className='quizhome_TitlePunjabi'>ਕਵਿਜ਼ ਦੀ ਕਿਸਮ ਚੁਣੋ</p>
        <p className='quizhome_Subtitle'>Pick a format and test your Punjabi knowledge</p>

        <div className='quizhome_Grid'>
          {quizTypes.map(({ to, icon: Icon, primary, secondary, desc, descPunjabi, badge, color }) => (
            <Link to={to} key={to} className={`quizhome_Card quizhome_Card--${color}`}>
              <div className='quizhome_CardTop'>
                <span className='quizhome_CardIcon' aria-hidden='true'>
                  <Icon />
                </span>
                <span className='quizhome_CardBadge'>{badge}</span>
              </div>
              <strong className='quizhome_CardTitle'>{primary}</strong>
              <span className='quizhome_CardTitlePunjabi'>{secondary}</span>
              <p className='quizhome_CardDesc'>{desc}</p>
              <p className='quizhome_CardDescPunjabi'>{descPunjabi}</p>
              <span className='quizhome_CardArrow' aria-hidden='true'>Start →</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default QuizHome
